// Converts an image file to a base64 data URL for storing directly on a Firestore document.
// Firestore documents have a 1MB total size limit, so keep uploaded images small —
// especially since an org doc may hold both a logo and a cover image plus text fields.
export const readImageAsBase64 = (file, maxSizeBytes = 300 * 1024) => {
  return new Promise((resolve) => {
    if (!file) {
      resolve({ base64: null, error: { message: "No file selected" } })
      return
    }

    if (!file.type?.startsWith("image/")) {
      resolve({ base64: null, error: { message: "File must be an image" } })
      return
    }

    if (file.size > maxSizeBytes) {
      resolve({
        base64: null,
        error: { message: `Image must be under ${Math.round(maxSizeBytes / 1024)}KB` },
      })
      return
    }

    const reader = new FileReader()
    reader.onloadend = () => resolve({ base64: reader.result, error: null })
    reader.onerror = () => resolve({ base64: null, error: { message: "Could not read file" } })
    reader.readAsDataURL(file)
  })
}